import { render, staticRenderFns } from "./ContestList.vue?vue&type=template&id=31745f12&scoped=true"
import script from "./ContestList.vue?vue&type=script&lang=ts"
export * from "./ContestList.vue?vue&type=script&lang=ts"
import style0 from "./ContestList.vue?vue&type=style&index=0&id=31745f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31745f12",
  null
  
)

export default component.exports